import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Drawer from "../Components/Drawer/Drawer";
import items from "../Data/DrawerData.json";
import config from "../config/config";
import { useMsal } from "@azure/msal-react";
import YesNoModal from "../Components/Modal/YesNoModal";
import { VscSignOut } from "react-icons/vsc";
import { useLanguage } from "../Components/Localization/LanguageContext";
import LanguageSwitcher from "../Components/Localization/LanguageSwitcher";
import strings from "../Components/Localization/strings";
import { jwtDecode } from "jwt-decode";
import ChooseTenant from "./ChooseTenant";
import ErrorBoundary from "../Components/ErrorBoundary";
//
function Admin(props) {
  const { language } = useLanguage();
  const pageTitle = "Admin";
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [userTenant, setUserTenant] = useState({});
  const [choseTenant, setChoseTenant] = useState(true);
  const [choseTenantFlag, setChoseTenantFlag] = useState(false);
  const [userName, setUserName] = useState("");
  const postLogoutURL = config.postLogoutURL;
  const logoutUrl =
    "https://login.microsoftonline.com/3f27056d-4d7b-420f-aed8-d0eb1fa914ca/oauth2/logout?post_logout_redirect_uri=" +
    postLogoutURL;

  const userTenantObj = JSON.parse(sessionStorage.getItem("userTenant"));

  const fetchUser = async () => {
    const tokenObject = await instance.acquireTokenSilent({
      account: instance.getActiveAccount(),
    });

    const token = tokenObject.idToken;
    //console.log(token);

    // const token = sessionStorage.getItem("token");
    const decodedToken = await jwtDecode(token);
    //console.log("decoded token is :", decodedToken);
    setUserName(decodedToken.name);
  };
  useEffect(() => {
    document.title = "Cayci - Admin";
    fetchUser();
  }, []);
  useEffect(() => {
    if (!userTenantObj) {
      // navigate("/choosetenant");
      setChoseTenant(false);
    } else {
      if (!choseTenantFlag) {
        setChoseTenant(true);
        setUserTenant(userTenantObj);
        setChoseTenantFlag(true);
      }

      // fetchUser();
    }
  }, [userTenantObj, choseTenant]);
  const handleAdminLogout = () => {
    // sessionStorage.removeItem("token");
    // sessionStorage.clear();
    // pca.clearCache();
    window !== window.parent
      ? instance
          .logoutPopup()
          .then(() => {
            console.log("logged out");
            sessionStorage.removeItem("userTenant");
            //sessionStorage.setItem("loginPopupShown", false);
            // navigate("/postLogout");
          })
          .catch((err) => {
            console.log("failed to logout", err);
          })
      : instance
          .logoutRedirect()
          .then(() => {
            console.log("logged out");
            sessionStorage.removeItem("userTenant");
            //sessionStorage.setItem("loginPopupShown", false);
            // navigate("/postLogout");
          })
          .catch((err) => {
            console.log("failed to logout", err);
          });
  };

  return (
    <ErrorBoundary>
      {choseTenant ? (
        <div className="home-page-container">
          <div className="nav-bar">
            <h3 style={{ fontWeight: "bold" }}>
              {strings[pageTitle][language].pageName}
            </h3>
            <div className="d-flex flex-wrap gap-1">
              <p className="user-info">{userTenant.name + " / " ?? ""}</p>
              <p className="user-info">{userName}</p>
            </div>
            <div style={{ display: "flex" }}>
              <div className="admin-logout">
                <LanguageSwitcher></LanguageSwitcher>
              </div>
              <div
                className="admin-logout"
                onClick={() => {
                  setShowLogoutModal(true);
                  /*
                instance.logoutPopup().then(()=>{
                  console.log("logged out")
                })*/
                }}
              >
                <VscSignOut size={25}></VscSignOut>
              </div>
            </div>
            <YesNoModal
              handleShowModal={(show) => setShowLogoutModal(show)}
              handleYes={() => {
                handleAdminLogout();
              }}
              propShow={showLogoutModal}
            >
              {strings[pageTitle][language].logoutConfirm}
            </YesNoModal>
          </div>
          <div className="main-container">
            <Drawer items={items[language]} />
            <Outlet />
          </div>
        </div>
      ) : (
        <ChooseTenant redirectUrl={"/"} />
      )}
    </ErrorBoundary>
  );
}

export default Admin;
